import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveProperty: ['property', 'onSuccess', 'onError'],
  removeProperty: ['property', 'onSuccess', 'onError'],
  savePropertyPlot: ['plot', 'onSuccess', 'onError'],
  removePropertyPlot: ['plot', 'onSuccess', 'onError'],
  savePropertyMap: ['map', 'onSuccess', 'onError'],
  removePropertyMap: ['map', 'onSuccess', 'onError'],
  saveHarvest: ['harvest', 'onSuccess', 'onError'],
  removeHarvest: ['harvest', 'onSuccess', 'onError'],
  setCurrentProperty: ['currentProperty', 'onSuccess', 'onError'],
  setDefaultProperty: ['property', 'onSuccess', 'onError'],
  resetCurrentProperty: [],
  setCurrentPropertyUnitOfMeasurement: ['measurement'],
  propertyError: ['error']
})

const saveProperty = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeProperty = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const savePropertyPlot = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removePropertyPlot = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const savePropertyMap = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removePropertyMap = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const saveHarvest = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeHarvest = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const setCurrentProperty = (state = INITIAL_STATE, { currentProperty }) => ({
  ...state,
  currentProperty
})

const resetCurrentProperty = (state = INITIAL_STATE) => ({
  ...state,
  currentProperty: INITIAL_STATE.currentProperty
})

const setCurrentPropertyUnitOfMeasurement = (state = INITIAL_STATE, { measurement }) => ({
  ...state,
  currentProperty: {
    ...state.currentProperty,
    measurement
  }
})

const propertyError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.PROPERTY_ERROR]: propertyError,

  [Types.SAVE_PROPERTY]: saveProperty,
  [Types.REMOVE_PROPERTY]: removeProperty,
  [Types.SAVE_PROPERTY_PLOT]: savePropertyPlot,
  [Types.REMOVE_PROPERTY_PLOT]: removePropertyPlot,
  [Types.SAVE_PROPERTY_MAP]: savePropertyMap,
  [Types.REMOVE_PROPERTY_MAP]: removePropertyMap,
  [Types.SAVE_HARVEST]: saveHarvest,
  [Types.REMOVE_HARVEST]: removeHarvest,

  [Types.SET_CURRENT_PROPERTY]: setCurrentProperty,
  [Types.RESET_CURRENT_PROPERTY]: resetCurrentProperty,

  [Types.SET_CURRENT_PROPERTY_UNIT_OF_MEASUREMENT]: setCurrentPropertyUnitOfMeasurement,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as PropertyTypes,
  Creators as PropertyActions
}
